// @flow

import * as React from 'react';
import { Flex, Box } from 'react-system';
import Input from '@material-ui/core/OutlinedInput';

type Props = {|
  length: number,
  onChange: (value: string) => void,
  disabled?: boolean,
|};

type State = {|
  values: $ReadOnlyArray<string>,
|};

const forwardRef: <T>(
  fn: (props: T, ref: React.Ref<'input'>) => React.Node,
) => React.ComponentType<T> = (React: any).forwardRef;

const Item = forwardRef((props, ref) => (
  <Box m={2} width={'56px'}>
    <Input
      css={{
        input: {
          textAlign: 'center',
        },
      }}
      inputRef={ref}
      labelWidth={0}
      maxLength="1"
      autoComplete="off"
      type="tel"
      autoFocus={props.autoFocus}
      value={props.value}
      disabled={props.disabled}
      onChange={e => {
        let { value } = e.target;
        const numCode = value.charCodeAt(0);
        const isInteger =
          numCode >= '0'.charCodeAt(0) && numCode <= '9'.charCodeAt(0);
        if (!isInteger) {
          value = '';
        }
        if (props.value === value) {
          return;
        }
        if (value.length < 2) {
          props.onChange(value);
        }
      }}
      onKeyDown={e => {
        if (e.keyCode === 8 && props.value.length === 0) {
          props.onBackspace();
        }
      }}
    />
  </Box>
));

export class PinInput extends React.Component<Props, State> {
  state: State = {
    values: Array.from<void, string>(Array(this.props.length), () => ''),
  };
  inputRefs: Array<any> = this.state.values.map<any>(() => React.createRef());
  render(): React.Node {
    return (
      <Flex justifyContent="center">
        {this.state.values.map((value, index) => (
          <Item
            key={index}
            disabled={this.props.disabled}
            ref={this.inputRefs[index]}
            value={value}
            autoFocus={index === 0}
            onChange={v => {
              this.setState(
                prev => ({
                  values: prev.values.map((d, i) => (index === i ? v : d)),
                }),
                () => {
                  // Set focus on next
                  if (v.length === 1 && index < this.props.length - 1) {
                    const { current } = this.inputRefs[index + 1];
                    if (current) {
                      current.focus();
                    }
                  }

                  // Notify the parent
                  const pin = this.state.values.join('');

                  if (pin.length === this.props.length) {
                    this.props.onChange(pin);
                  }
                },
              );
            }}
            onBackspace={() => {
              if (index !== 0) {
                const { current } = this.inputRefs[index - 1];
                if (current) {
                  current.focus();
                }
              }
            }}
          />
        ))}
      </Flex>
    );
  }
}
